import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import { LBL_DEPARTMENTS, LBL_SKILLS, LBL_DATE_OF_JOIN, LBL_LAST_LOGIN, LBL_SELECT, LBL_DATE_FROM, LBL_DATE_TO, LBL_CHIEF,  LBL_CREW_CHIEF, LBL_CREW, LBL_INDUCTION, LBL_COMPLETED, LBL_PENDING, LBL_AVAILABILITY, LBL_AVAILABLE, LBL_UNAVAILABLE, LBL_ACTIVE, LBL_INACTIVE, LBL_APPROVAL, LBL_APPROVED, LBL_ALL, LBL_ADDED_BY, LBL_OTHER_AFFILIATES, LBL_HAS_VEHICLE, LBL_YES, LBL_NO, LBL_NOT_APPROVED} from '../../configs/labelConfigs';
import { MSG_REQUIRED } from '../..//configs/msgConfigs'; 
import CustomMultiSelect from '../../components/commons/helpers/customMultiSelect';
import DatePicker from "react-datepicker"; 
import "react-datepicker/dist/react-datepicker.css";
import { format } from 'date-fns';

import { getUserGroupData } from '../../utils/browserStorage';
import { crewAffSkillListAction} from '../../actions/crewActions';
import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import {titleCase} from '../../utils/changeCase';
import { serverTimeAction} from '../../actions/commonActions';


import * as types from '../../actions';


class FilterCrew extends Component {
    
    constructor(props){
        super(props)
        let userGroupData = userGroupUrlCheck(window.location);
        this.state = { 
            
            skillListCalled: 0, 

            skillMultiList: [],

            skillIds: [],

            is_chief: '',
            is_inducted: '',
            is_approved: '',
            is_available: '',
            is_active: 'true',
            is_omnu: '',
            has_vehicle: '',

            selDateType: '',
            selectedStartDate: new Date(),
            defaultStartDate: new Date(),
            selectedEndDate: new Date(), 
            defaultEndDate: new Date(), 

            resetFilterClicked: 0,
            applyFilterClicked: 0,
            formErrors_selectedToDate:'',
            departmentsList:[],
            deptMultiSelList:[],
            selectedDepartments:[],
            approvalPending: 0,
            showAllUnapprovedCrews: 0,
        }
    }

    onskillDataChange = (selectedStatus) =>{
        let skillIds = [];
        selectedStatus.forEach((item) => {
            skillIds.push(parseInt(item.value,10));
        });
        this.setState({skillIds:skillIds});
    }

    onSelectOption = (e) => {
        let stateVar = this.state; 
        stateVar[e.target.name] = e.target.value; 
        this.setState({...stateVar}); 
    }

    onDateCheck = (e) => {
        let stateVar = this.state; 
        stateVar[e.target.name] = e.target.checked; 
        this.setState({...stateVar}); 
    }

    onSelectDateType = (e) => {
        this.setState({selDateType:e.target.value}); 
    }

    onStartDateChange = (date) =>{
        let startDate = new Date(date);
        if(this.state.selectedEndDate < startDate) {
            this.setState({selectedStartDate:startDate,selectedEndDate:startDate});    
        }
        else {
            this.setState({selectedStartDate:startDate});    
        }
    }

    onEndDateChange = (date) =>{ 
        let endDate = new Date(date);
        this.setState({selectedEndDate:endDate});  
    }

    resetFilters = (actionType) => { 
        let skillMultiList = this.state.skillMultiList; // TO RESET MULTISEL VALUES
        let userGroupData = userGroupUrlCheck(window.location);
        this.setState({ 
            skillMultiList: [],
            skillIds: [],
            is_chief: '',
            is_inducted: '',
            is_approved: '',
            is_available: '',
            is_omnu: '',
            is_active: 'true',
            has_vehicle: '',
            selDateType: '',
            selectedStartDate: this.state.defaultStartDate,
            selectedEndDate: this.state.defaultEndDate, 
            resetFilterClicked: 0,
            applyFilterClicked: 0,
            formErrors_selectedToDate:'',
            selectedDepartments:[],
        }, () => {
            this.setState({skillMultiList:skillMultiList});  // TO RESET MULTISEL VALUES 
            this.loadMultiSelDeptValues();
            if(actionType=='listApprovalPending') { 
                this.setState({is_approved:'false'}); 
                this.sendFilterData(); 
            }
        }); 
    }

    sendFilterData = () => {
        let foundIssues = 0;

        // VALIDATE WHETHER FROM DATE IS GREATER THAN TO DATE 
        let dateTimeFrom = new Date();
        let dateTimeTo   = new Date();
        if(this.state.selDateType!=='') {
            dateTimeFrom = new Date(this.state.selectedStartDate);
            dateTimeTo = new Date(this.state.selectedEndDate); 
            if(dateTimeFrom > dateTimeTo) {
                foundIssues = 1;
                this.setState({formErrors_selectedToDate:MSG_REQUIRED}); 
                this.props.onShowFilterBy(); 
                return false;          
            }
        }  


        if(foundIssues===0) { 
            let filtersSelected = 0; 
            let departments = [];
            let arrSkillIds = []; 
            this.state.skillIds.forEach(item => { arrSkillIds.push(Number(item)); }); 
            if(arrSkillIds.length) filtersSelected = 1; 

            if(this.state.is_chief.length > 1 || this.state.is_inducted.length > 1 || this.state.is_approved.length > 1 || this.state.is_active === 'false' || this.state.is_active === 'all' || this.state.is_available.length > 1 || this.state.is_omnu.length > 1 || this.state.has_vehicle.length > 1) {
                filtersSelected = 1;
            }
            if(this.state.selectedDepartments.length){
                filtersSelected = 1; 
                departments = this.state.selectedDepartments
                if(this.state.deptMultiSelList.length === this.state.selectedDepartments.length){
                    departments.push('all');
                }
            }
            let fromDate = 0; 
            let endDate = 0;
            if(this.state.selDateType.length > 1) {
                fromDate = format(new Date(this.state.selectedStartDate), 'yyyy-MM-dd');
                endDate = format(new Date(this.state.selectedEndDate), 'yyyy-MM-dd');
                filtersSelected = 1;
            }
            
            let filterData = {departments:departments, skillIds:arrSkillIds, is_chief:this.state.is_chief, is_inducted:this.state.is_inducted, is_approved:this.state.is_approved, is_active:this.state.is_active, has_vehicle:this.state.has_vehicle, is_available:this.state.is_available, is_omnu:this.state.is_omnu, date_type:this.state.selDateType, from_date:fromDate, to_date:endDate, filtersSelected:filtersSelected}; 
            this.props.applyFilters(filterData); 
        }
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        let selectedDepartments = [];
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
            let inputVal = 0;
            if(this.state.showAllUnapprovedCrews === 0){
                inputVal = 1
                selectedDepartments.push(item.id)
            }
              tmpObj = {value:item.id, label:titleCase(item.name), inputVal:inputVal}; 
              allDept.push(tmpObj); 
           }) 
           
            this.setState({deptMultiSelList:allDept,selectedDepartments:selectedDepartments},()=>{
                this.sendFilterData()
            }); 
        }
     }
    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        }); 
        this.setState({selectedDepartments:actUserDept}); 
    }

    componentDidMount() {
        this.props.serverTimeAction();
    }

    componentDidUpdate (prevProps) {

        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                // let defaultEndDate = new Date(this.props.serverTimeList.current_date+" 00:00:00");
                let defaultEndDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                this.setState({defaultStartDate:defaultEndDate,defaultEndDate:defaultEndDate,
                            selectedStartDate:defaultEndDate,selectedEndDate:defaultEndDate})
            }
        } 

        if(parseInt(this.props.approvalPending,10) > parseInt(this.state.approvalPending,10)) {
            this.setState({approvalPending:this.props.approvalPending}); 
            this.resetFilters('listApprovalPending'); 
        }

        if(this.props.filterClicked!==prevProps.filterClicked && this.state.skillListCalled===0) {
            this.setState({skillListCalled:1}); // TO PREVENT REPEATED API CALLS 
            if(this.props.clientId && this.props.clientId > 0) {
                let storageData = getUserGroupData('client'); 
                this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:'',clientId:this.props.clientId,affId:storageData.client_default_affiliate_id});
                this.props.aflt_departmentsListAction({page:0,column:'name',pageSize:'',clientId:this.props.clientId,affId:storageData.client_default_affiliate_id,associated:'1'});
            }
            else {
                this.props.crewAffSkillListAction({page:0,column:'skill_name',pageSize:''});
                this.props.aflt_departmentsListAction({page:0,column:'name',pageSize:'',associated:'1'});
            }
        } 
        else if(this.props.filterClicked!==prevProps.filterClicked) {
            this.props.aflt_departmentsListAction({page:0,column:'name',pageSize:'',associated:'1'});
        } 

        if(this.props.applyFilterClicked > 0 && this.props.applyFilterClicked!==prevProps.applyFilterClicked && this.state.applyFilterClicked < this.props.applyFilterClicked) {
            this.setState({applyFilterClicked:this.props.applyFilterClicked}); // TO PREVENT REPEATED API CALLS 
            this.sendFilterData(); 
        }

        if(this.props.resetFilterClicked > 0 && this.props.resetFilterClicked!==prevProps.resetFilterClicked && this.state.resetFilterClicked < this.props.resetFilterClicked) {
            this.setState({resetFilterClicked:this.props.resetFilterClicked,showAllUnapprovedCrews:0}); // TO PREVENT REPEATED API CALLS 
            this.resetFilters(''); 
        }

        if(this.props.showAllUnapprovedCrews > 0 && this.props.showAllUnapprovedCrews!==prevProps.showAllUnapprovedCrews && this.state.showAllUnapprovedCrews < this.props.showAllUnapprovedCrews) {
            this.setState({showAllUnapprovedCrews:this.props.showAllUnapprovedCrews,applyFilterClicked:this.state.applyFilterClicked+1,is_approved:'false',selectedDepartments:[]},()=>{
                this.loadMultiSelDeptValues();
            });
        }

        const {subactivity,skillList,crewProfileActivity} = this.props; 

        if(subactivity && subactivity !== prevProps.subactivity) {
            let arrResp = subactivity.split('~~'); 
            let actString = arrResp[0]; 

            if(actString===types.CREW_AFFILIATE_SKILL_LIST_SUCCESS){
                //console.log('skillList'); 
                //console.log(skillList); 
                let skillMultiList = [];
                if(Array.isArray(skillList) && skillList.length>0){
                    skillList.forEach(item => {
                        skillMultiList.push({value:item.id,label:item.skill_name});
                    });
                }
                this.setState({skillMultiList});
            }
        }
        if(crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity){
            let arrResp = crewProfileActivity.split('~~'); 
            let actString = arrResp[0]; 
            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS){
                if(this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                    if(this.props.afltDepartmentsForCrew.length===0) {
                          this.setState({departmentsList: []}, () => {
                             this.loadMultiSelDeptValues(); 
                          } ); 
                    }
                    else {     
                          this.setState({departmentsList: this.props.afltDepartmentsForCrew}, () => {
                             this.loadMultiSelDeptValues(); 
                          } );                  
                    }
                }
            }
        }
        
    }

    render(){

        const {subactivity,errorData,status,skillList,isClientPage} = this.props;  
        const {deptMultiSelList,skillMultiList,selDateType,is_chief,is_inducted,is_approved,is_available,is_omnu,is_active,has_vehicle,selectedStartDate,selectedEndDate,formErrors_selectedToDate} = this.state; 

        let paddingTopPix = 250; // TO GIVE SPACE AT BOTTOM
        let userGroupData = userGroupUrlCheck(window.location);
        let supervisor_name = ''; 
        let crew_chief = ''; 
        if(userGroupData!==undefined){
            supervisor_name = userGroupData.supervisor_name
            crew_chief = userGroupData.supervisor_name
        }
        if(!supervisor_name){
            supervisor_name = LBL_CHIEF;
            crew_chief = LBL_CREW_CHIEF
        }

        return(
            <React.Fragment>
                <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_SKILLS}</h4>
                        <div className="form-group multisel_textbox">
                            <div className="form-group select-input skills" >
                                <CustomMultiSelect data={skillMultiList}  onChange={selected =>this.onskillDataChange(selected)} isTextBox={false} needSelectAll={true} />
                            </div>
                        </div>
                    </div> 
                </div>
                <div className="filter-category">
                    <div className="form-group">
                        <h4>{LBL_DEPARTMENTS}</h4>
                        <div className="form-group multisel_textbox">
                                <div className="form-group select-input skills" >
                                <CustomMultiSelect data={deptMultiSelList} trimString='yes'  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} marginTop0='marginTop0' inputProps={{ tabIndex:"10" }} tabIndex="10" needSelectAll={true} />
                                </div>
                        </div> 
                    </div>
                </div>
                {/*userGroupData.omnu_affiliate && <div className="filter-category" >
                    <div className="form-group">                 
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_ADDED_BY}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="is_omnu" value={is_omnu}  >
                                        <option value="true" >{userGroupData.company_name}</option> 
                                        <option value="false" >{LBL_OTHER_AFFILIATES}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>*/}

                <div className="filter-category">      
                    <div className="form-group">              
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{supervisor_name}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="is_chief" value={is_chief}  >
                                        <option value="" data-loc="">{LBL_ALL}</option>
                                        <option value='true' >{crew_chief}</option> 
                                        <option value='false' >{LBL_CREW}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>      
                    </div>      
                </div>
                
                {this.props.hideInduction!=='yes' && <div className="filter-category">   
                    <div className="form-group">                 
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_INDUCTION}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="is_inducted" value={is_inducted}  >
                                        <option value="" data-loc="">{LBL_ALL}</option>
                                        <option value='true' >{LBL_COMPLETED}</option> 
                                        <option value='false' >{LBL_PENDING}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>     
                    </div>     
                </div>} 


                {this.props.hideApproval!=='yes' && <div className="filter-category">   
                    <div className="form-group">                 
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_APPROVAL}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="is_approved" value={is_approved}  >
                                        <option value="" data-loc="">{LBL_ALL}</option>
                                        <option value='true' >{LBL_APPROVED}</option> 
                                        <option value='false' >{LBL_PENDING}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>}

                {this.props.hideAvailability!=='yes' && <div className="filter-category">   
                    <div className="form-group">                 
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_AVAILABILITY}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="is_available" value={is_available}  >
                                        <option value="" data-loc="">{LBL_ALL}</option>
                                        <option value='true' >{LBL_AVAILABLE}</option> 
                                        <option value='false' >{LBL_UNAVAILABLE}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>}


                {this.props.hideActive!=='yes' && <div className="filter-category">   
                    <div className="form-group">                 
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_ACTIVE}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="is_active" value={is_active}  >
                                        <option value="all" data-loc="">{LBL_ALL}</option>
                                        <option value='true' >{LBL_ACTIVE}</option> 
                                        <option value='false' >{LBL_INACTIVE}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>}

                <div className="filter-category">   
                    <div className="form-group">                 
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_HAS_VEHICLE}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectOption(e)} name="has_vehicle" value={has_vehicle}  >
                                        <option value="" data-loc="">{LBL_ALL}</option>
                                        <option value='true' >{LBL_YES}</option> 
                                        <option value='false' >{LBL_NO}</option> 
                                        {this.props.hideVehicleNotApproved!=='yes' && <option value='not_approved' >{LBL_NOT_APPROVED}</option>}
                                    </select>                                
                                </div>
                            </div>
                        </div>     
                    </div>
                </div>
                
                {this.props.hideDateOfJoin!=='yes' && <div className="filter-category">     
                    <div className="form-group">    
                        <div className="row"> 
                            <div className="col-12">
                                <h4>{LBL_DATE_OF_JOIN+' / '+LBL_LAST_LOGIN}</h4> 
                                <div className="select-input">  
                                    <select onChange={(e) => this.onSelectDateType(e)} name="selDateType" value={selDateType}  >
                                        <option value="" data-loc="">{LBL_SELECT}</option>
                                        <option value='join' >{LBL_DATE_OF_JOIN}</option> 
                                        <option value='login' >{LBL_LAST_LOGIN}</option> 
                                    </select>                                
                                </div>
                            </div>
                        </div> 
                          
                        {selDateType!=='' && <div className="row padding-top-10"> 
                            <div className="col-6"> <h4>{LBL_DATE_FROM} </h4></div>
                            <div className="col-6"> <h4>{LBL_DATE_TO}</h4></div>
                            <div className="col-6">
                                <div className="calendar-input">  
                                    <DatePicker 
                                        selected={selectedStartDate}
                                        onChange={selected => this.onStartDateChange(selected)}
                                        name="startDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="Select"
                                        //maxDate={new Date()}
                                        // minDate={new Date()}
                                        fixedHeight   
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="calendar-input ">  
                                    <DatePicker 
                                        selected={selectedEndDate}
                                        onChange={selected => this.onEndDateChange(selected)}
                                        name="endDate"
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText="Select"
                                        //maxDate={new Date()}
                                        minDate={new Date(selectedStartDate)}
                                        fixedHeight     
                                        className={formErrors_selectedToDate.length >0 ? "input-error" : ''}    
                                    />
                                </div>
                            </div>
                        </div>}

                    </div>
                </div>} 

                <div> &nbsp; </div>

                <div style={{paddingTop:paddingTopPix}}></div>

                             
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        subactivity:state.event.subactivity, 
        skillList:state.event.skillList,
        errorData:state.event.errorData,
        afltDepartmentsForCrew:state.crews.afltDepartmentsForCrew,
        departmentsList: state.afltDepartments.departmentsList,
        crewProfileActivity:state.crews.crewProfileActivity,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity    
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewAffSkillListAction:crewAffSkillListAction,
        aflt_departmentsListAction:aflt_departmentsListAction,
        serverTimeAction:serverTimeAction

    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(FilterCrew); 
